export default __webpack_public_path__ + "static/media/background3.4c645e33.jpg";